import { Injectable } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { CriticalPointTemplate } from "src/app/classes/model/practice-path";
import { CriticalPointTemplateSelectorDialogComponent } from "../components/critical-point-template-selector-dialog/critical-point-template-selector-dialog.component";

@Injectable({
  providedIn: "root",
})
export class CriticalPointTemplateSelectorService {
  constructor(private readonly dialog: MatDialog) {}

  /**
   * Opens the critical point template selector dialog.
   * 
   * @returns A MatDialogRef that resolves with the selected template or undefined if cancelled
   */
  open(): MatDialogRef<CriticalPointTemplateSelectorDialogComponent, CriticalPointTemplate | undefined> {
    return this.dialog.open<
      CriticalPointTemplateSelectorDialogComponent,
      void,
      CriticalPointTemplate | undefined
    >(CriticalPointTemplateSelectorDialogComponent, {
      width: "900px",
      maxWidth: "95vw",
      maxHeight: "90vh",
      disableClose: false,
    });
  }
}

